module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.c104868d.svg";